import { LinkIcon, LocationIcon, SparkleIcon } from '@/assets/icons'
import { countLabel } from '@/utils/plural'
import { daysBetween, formatCalendarDate } from '@lib/datetime'
import { Button } from '@components/Button'
import React from 'react'
import {
	DateDisplayText,
	DateDisplayValue,
	DateRangeDisplay,
	DateSelectorContainer,
	DateSeparator,
	DaysCount,
	ToolbarActions,
} from './DateSelector.styles'
import { DateSelectorProps } from './types'
import { iconSizes } from '@/theme/tokens'

const DateSelector: React.FC<DateSelectorProps> = ({ initialStartDate, initialEndDate, onEditClick, onShareClick, onMapClick, onImportClick }) => {
	const formatDateDisplay = (date: string): string => {
		if (!date) return 'Not set'
		return formatCalendarDate(date, 'medium') || 'Not set'
	}

	const calculateDays = (): number => {
		if (!initialStartDate || !initialEndDate) return 0
		return daysBetween(initialStartDate, initialEndDate) + 1
	}

	const dayCount = calculateDays()

	return (
		<DateSelectorContainer>
			<DateRangeDisplay>
				{dayCount > 0 && (
					<DaysCount>
						{countLabel(dayCount, 'Day')}
					</DaysCount>
				)}

				<DateSeparator>-</DateSeparator>

				<DateDisplayText>
					<DateDisplayValue>{formatDateDisplay(initialStartDate)}</DateDisplayValue>
					<DateSeparator>to</DateSeparator>
					<DateDisplayValue>{formatDateDisplay(initialEndDate)}</DateDisplayValue>
				</DateDisplayText>

				{onEditClick && (
					<>
						<DateSeparator>-</DateSeparator>
						<Button variant="secondary" size="sm" onClick={onEditClick}>
							Edit Destinations
						</Button>
					</>
				)}
			</DateRangeDisplay>

			{(onImportClick || onMapClick || onShareClick) && (
				<ToolbarActions>
					{onImportClick && (
						<Button variant="cool" size="sm" onClick={onImportClick}>
							<SparkleIcon sx={{ fontSize: iconSizes.xs }} />
							Import
						</Button>
					)}

					{onMapClick && (
						<Button size="sm" onClick={onMapClick}>
							<LocationIcon sx={{ fontSize: iconSizes.xs }} />
							View Map
						</Button>
					)}

					{onShareClick && (
						<Button variant="ghost" size="sm" onClick={onShareClick}>
							<LinkIcon sx={{ fontSize: iconSizes.xs }} />
							Share Itinerary
						</Button>
					)}
				</ToolbarActions>
			)}
		</DateSelectorContainer>
	)
}

export default DateSelector
